/**
 * /p/mock-ars — Página estática con datos mock en ARS
 *
 * Simula la respuesta de GET /api/products/by-slug?slug=mock-ars&country=AR
 * Producto solo ARS. Checkout → MercadoPago.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { mockProductStaticArs } from '@/mocks/productBySlug';

const product = mockProductStaticArs;

export default function ProductPageMockArs() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = product.page_title || product.name;
  }, []);

  const handlePagar = () => {
    alert(`[MOCK ARS] Pasarela: MercadoPago\nPrecio: $${product.recommended_price.toLocaleString('es-AR')} ${product.recommended_currency}\nEn producción se abriría el checkout de MercadoPago.`);
  };

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-50 bg-emerald-500/90 text-white text-center py-1 text-sm font-medium">
        🧪 Mock ARS — Checkout MercadoPago
      </div>
      <div className="min-h-screen bg-black py-12 px-4 pt-14">
        <article className="max-w-lg mx-auto">
          {(product.hero_image_url || product.image_url) && (
            <div className="rounded-xl overflow-hidden mb-6 bg-white/10 aspect-video">
              <img
                src={product.hero_image_url || product.image_url}
                alt={product.image_alt || product.name}
                className="w-full h-full object-cover"
              />
            </div>
          )}
          <h1 className="text-2xl font-semibold text-white mb-2">{product.name}</h1>
          <p className="text-white/60 mb-6 whitespace-pre-wrap">{product.page_description || product.description}</p>
          <div className="flex items-baseline gap-2 mb-6">
            <span className="text-3xl font-bold text-white">
              $ {product.recommended_price.toLocaleString('es-AR')} {product.recommended_currency}
            </span>
          </div>
          <Button
            size="lg"
            className="w-full bg-white text-black font-semibold hover:bg-white/90"
            onClick={handlePagar}
          >
            {product.cta_button_text || 'Comprar'}
          </Button>
          <Button
            variant="ghost"
            className="w-full mt-3 text-white/60 hover:text-white hover:bg-white/10"
            onClick={() => navigate('/')}
          >
            Volver al inicio
          </Button>
        </article>
      </div>
    </>
  );
}
